const topics = [
  { title: '明星恋情实锤合集', desc: '近期被拍到实锤的明星恋情汇总，持续更新中', count: '128条', icon: 'ri-heart-pulse-line', hot: true },
  { title: '综艺节目争议事件', desc: '各档热门综艺录制现场的争议和冲突盘点', count: '96条', icon: 'ri-tv-line', hot: true },
  { title: '网红翻车大赏', desc: '那些年翻车的网红们，从爆火到塌房全记录', count: '215条', icon: 'ri-emotion-sad-line', hot: false },
  { title: '娱乐圈税务风波', desc: '明星偷税漏税被查事件全追踪，定期更新进展', count: '73条', icon: 'ri-file-warning-line', hot: true },
  { title: '直播带货内幕', desc: '头部主播数据造假、产品质量问题的深度调查', count: '167条', icon: 'ri-shopping-bag-3-line', hot: false },
  { title: '影视圈潜规则', desc: '选角黑幕、片酬争议、剧组乱象一网打尽', count: '142条', icon: 'ri-movie-2-line', hot: false },
  { title: '粉丝应援争议', desc: '饭圈文化引发的各种争议事件和讨论汇总', count: '89条', icon: 'ri-group-line', hot: false },
];

export default function TopicIndex() {
  return (
    <section id="index" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1100px] mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <span className="w-1 h-7 bg-accent-500 rounded-full"></span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">热门专题</h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          {topics.map((item, i) => (
            <div
              key={i}
              className="group bg-background-100 hover:bg-background-200/70 border border-background-200/70 rounded-xl p-5 transition-all cursor-pointer"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-3">
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <div className="flex items-center gap-2 mb-2">
                <h3 className="font-heading text-base font-bold text-foreground-900 group-hover:text-primary-500 transition-colors">{item.title}</h3>
                {item.hot && <span className="text-[10px] bg-primary-100 text-primary-600 px-1.5 py-0.5 rounded whitespace-nowrap">热门</span>}
              </div>
              <p className="text-xs text-foreground-500 leading-relaxed mb-3">{item.desc}</p>
              <span className="text-xs text-accent-600 font-medium">{item.count}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}